import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PublicNavigation.css';

function PublicNavigation() {
  const { currentUser, userProfile, isAdmin } = useAuth();

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <Link to="/projects">
          <div className="brand-content">
            <img src="/tnf-logo.png" alt="TNF USA Logo" className="brand-logo" />
            <div className="brand-text">
              <h2>TNF USA</h2>
              <p>Together We Serve</p>
            </div>
          </div>
        </Link>
      </div>

      <div className="nav-links">
        <Link to="/projects" className="nav-link">Projects</Link>
        
        {currentUser ? (
          <>
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/my-projects" className="nav-link">My Projects</Link>
            
            {isAdmin && (
              <div className="nav-dropdown">
                <span className="nav-link">Admin ▾</span>
                <div className="dropdown-content">
                  <Link to="/admin/projects">Manage Projects</Link>
                  <Link to="/admin/chapters">Manage Chapters</Link>
                  <Link to="/admin/users">Manage Users</Link>
                  <Link to="/admin/interests">View Interests</Link>
		  <Link to="/tools/pdf-comparison">📊 Compare Reports</Link>
                  <Link to="/admin/manual-entry">Manual Entry</Link>
                  <Link to="/admin/report-builder">Report Builder</Link>
                  <Link to="/admin/reports/upload">Upload Report</Link>
                  <Link to="/dashboards/executive">Executive Dashboard</Link>
		  <Link to="/dashboards/manual-projects">📊 Projects Dashboard</Link>
		  <Link to="/dashboards/chapters">📊 Chapter KPIs</Link>
                </div>
              </div>
            )}
          </>
        ) : (
          <Link to="/login" className="nav-link">Login</Link>
        )}
      </div>

      {currentUser && (
        <div className="nav-user">
          <span className="user-name">{userProfile?.displayName}</span>
        </div>
      )}
    </nav>
  );
}

export default PublicNavigation;
